import { FooterWrapper, FooterText } from './styles'

const COPYRIGHT_CREDITS = ['eltonvs', 'thaislins']

function Footer() {
	return (
		<FooterWrapper>
			<div className="container">
				<FooterText>
					&copy; {new Date().getFullYear()} - Made with ❤️ by{' '}
					{COPYRIGHT_CREDITS.map((name, index) => (
						<>
							<a
								key={name}
								href={`https://github.com/${name}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								@{name}
							</a>
							{index < COPYRIGHT_CREDITS.length - 1 && ' and '}
						</>
					))}
				</FooterText>
			</div>
		</FooterWrapper>
	)
}

export default Footer
